import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();

    async function handleSubmit(e: React.FormEvent) {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            await login(email, password);
            navigate('/');
        } catch (err) {
            setError(err instanceof Error ? err.message : 'An error occurred');
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="login-page">
            <div className="login-container">
                <div className="login-header">
                    <div className="login-logo">🛡️</div>
                    <h1>HSA Tracker</h1>
                    <p className="login-subtitle">Preserve receipts and review reimbursement records</p>
                </div>

                <div className="login-card">
                    <h2>Login</h2>
                    <p>New accounts require administrator review.</p>
                    <form onSubmit={handleSubmit} className="login-form">
                        {error && (
                            <div className="error-message" role="alert">
                                ⚠️ {error}
                            </div>
                        )}

                        <div className="form-group">
                            <label htmlFor="email">Email</label>
                            <input
                                id="email"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="you@example.com"
                                required
                                autoComplete="email"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="password">Password</label>
                            <input
                                id="password"
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="••••••••"
                                required
                                minLength={6}
                                autoComplete="current-password"
                            />
                        </div>

                        <button
                            type="submit"
                            className="btn btn-primary submit-btn"
                            disabled={loading}
                        >
                            {loading ? '⏳ Loading...' : '🔓 Login'}
                        </button>
                    </form>
                </div>

                <p className="login-features">
                    ✓ Original receipt storage &nbsp;&nbsp;
                    ✓ Multi-device access &nbsp;&nbsp;
                    ✓ 10+ year storage
                </p>
            </div>
        </div>
    );
}
